import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, CheckCircle2, ArrowRight, Instagram, ShieldCheck, ShoppingCart } from 'lucide-react';
import { PRODUCTS } from '../data/products';
import { useCartStore } from '../store/useCartStore';
export function ProductPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const {
    addItem,
    items,
    openCart
  } = useCartStore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-id="element-240" data-mp="exozk8xxhpf5">
        <div className="text-center" data-id="element-241" data-mp="9wj628wg1y4k">
          <h1 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-242" data-mp="9znexjkuti1k">
            Товар не знайдено
          </h1>
          <button onClick={() => navigate('/')} className="text-brand-yellow font-bold hover:underline" data-id="element-243" data-mp="1lchgoh79ss7w">
            Повернутися на головну
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-yellow selection:text-brand-blueDark font-sans pt-24" data-id="element-244" data-mp="1goplir64vtjx">
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-8 lg:py-16" data-id="element-245" data-mp="1lmr1324cpaqn">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-muted hover:text-brand-blue font-bold mb-8 transition-colors" data-id="element-246" data-mp="1qmlubcblmcev">
          <ArrowLeft className="w-5 h-5" data-id="element-247" data-mp="xypx86i4aihk" />
          Назад до всіх планерів
        </Link>

        <div className="bg-white rounded-lg shadow-card border border-black/5 p-6 lg:p-10" data-id="element-248" data-mp="12ym185qte9x4">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12" data-id="element-249" data-mp="17p2iy21o4hpa">
            {/* Мобільний заголовок та бейдж (видно тільки на мобільному) */}
            <div className="lg:hidden flex flex-col items-center text-center gap-3 mb-2" data-id="element-250" data-mp="a8vj7lm2anvq">
              <div className="inline-flex items-center justify-center gap-1.5 text-gray-500" data-id="element-251" data-mp="f7gohzg67xr1">
                <ShieldCheck className="w-4 h-4" data-id="element-252" data-mp="770mirano8qa" />
                <span className="font-medium text-xs uppercase tracking-wider" data-id="element-253" data-mp="75pkox0rtb1t">
                  В наявності
                </span>
              </div>
              <h1 className="text-3xl font-black text-brand-blue leading-tight" data-id="element-254" data-mp="gwk4zvugi0km">
                {product.title}
              </h1>
            </div>

            {/* Ліва частина: Фото */}
            <div className="w-full lg:w-1/2 flex-shrink-0" data-id="element-255" data-mp="3kfn6zrsmsoid">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5
            }} className="relative w-full rounded-2xl overflow-hidden border border-gray-100 bg-gray-50" data-id="element-256" data-mp="3gd0b9fsuajfw">
                <img src={product.img} alt={product.title} className="w-full h-auto object-contain" data-id="element-257" data-mp="14meimfmlnt5x" />
              </motion.div>
            </div>

            {/* Права частина: Інформація */}
            <div className="w-full lg:w-1/2 flex flex-col text-center lg:text-left" data-id="element-258" data-mp="2dko11od9jmih">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="flex flex-col h-full" data-id="element-259" data-mp="2dmr1l2c1ky1g">
                {/* Десктопний заголовок та бейдж (сховано на мобільному) */}
                <div className="hidden lg:flex flex-col gap-4 mb-6" data-id="element-260" data-mp="31g8v3igpjej0">
                  <div className="inline-flex items-center gap-1.5 text-gray-500" data-id="element-261" data-mp="3p75xo4mm4zhl">
                    <ShieldCheck className="w-4 h-4" data-id="element-262" data-mp="3tyw9yg541xbn" />
                    <span className="font-medium text-xs uppercase tracking-wider" data-id="element-263" data-mp="3u0h80fqmvye9">
                      В наявності
                    </span>
                  </div>
                  <h1 className="text-4xl lg:text-5xl font-black text-brand-blue leading-tight" data-id="element-264" data-mp="20c70rv8gacqe">
                    {product.title}
                  </h1>
                </div>

                <p className="text-lg text-brand-muted font-medium mb-8 leading-relaxed" data-id="element-265" data-mp="1re3qxw6tv4ef">
                  {product.fullDesc}
                </p>

                <div className="space-y-4 mb-8 text-left" data-id="element-266" data-mp="2o55nnqsx1r98">
                  <h3 className="font-bold text-brand-blue text-lg mb-2 text-center lg:text-left" data-id="element-267" data-mp="2k30vyxm134p8">
                    Що ви отримуєте:
                  </h3>
                  <div className="flex items-start gap-3" data-id="element-268" data-mp="2ac68xr0yk12q">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-269" data-mp="2abo4w8820ik9" />
                    <div data-id="element-270" data-mp="37svb5lttl5cn">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-271" data-mp="37t51xbmovgje">
                        Повністю магнітна основа
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-272" data-mp="3ad1lcb911s1n">
                        Надійно тримається на холодильнику, не сповзає.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-273" data-mp="3k8mi9uz8o24j">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-274" data-mp="3obrkdwfeq1sn" />
                    <div data-id="element-275" data-mp="3tb43q772kqqh">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-276" data-mp="3t9t3ghcu2144">
                        Маркер з губкою в комплекті
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-277" data-mp="6uhsb6iiyi5s">
                        Легко пише та стирається без слідів.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-278" data-mp="fw7u96a18zht">
                    <CheckCircle2 className="w-5 h-5 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-279" data-mp="ftmseh9qijk2" />
                    <div data-id="element-280" data-mp="kspxg1ppsps1">
                      <span className="font-bold text-brand-blue block text-sm" data-id="element-281" data-mp="2gxnviwnftqa2">
                        Багаторазове використання
                      </span>
                      <span className="text-brand-muted text-sm" data-id="element-282" data-mp="2cy6ohysd4l2s">
                        Пишіть, стирайте та плануйте знову і знову.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-283" data-mp="30lwkkxtopg5c">
                  <div className="text-center sm:text-left w-full sm:w-auto" data-id="element-284" data-mp="2vls437ss0lf4">
                    <p className="text-sm text-brand-muted font-bold uppercase tracking-wider mb-1" data-id="element-285" data-mp="39n4kfkbump1j">
                      Вартість
                    </p>
                    <div className="text-4xl font-black text-brand-blue" data-id="element-286" data-mp="34ob2nfpj4bvk">
                      {product.price}{' '}
                      <span className="text-xl text-brand-muted" data-id="element-287" data-mp="1faensuu3j1qg">грн</span>
                    </div>
                  </div>
                  <button onClick={() => addItem(product)} className="w-full sm:w-auto px-8 py-4 bg-brand-blue hover:bg-brand-blueDark text-white rounded-xl font-bold text-base tracking-wide shadow-button transition-colors duration-200 flex items-center justify-center gap-2" data-id="element-288" data-mp="3lwc21bjjcksw">
                    Замовити зараз
                    <ArrowRight className="w-4 h-4" strokeWidth={2} data-id="element-289" data-mp="3h3rakgo3qjsj" />
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-brand-blueDark text-white py-10 mt-20" data-id="element-290" data-mp="2u5xury6126q7">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-291" data-mp="2u7r4xnfun92y">
          <div className="text-2xl font-black tracking-tight flex items-center" data-id="element-292" data-mp="seb98c4wn414">
            <span className="text-brand-yellow font-script italic mr-1" data-id="element-293" data-mp="sc711hzz3iv1">
              My
            </span>
            <span className="text-white" data-id="element-294" data-mp="wdk1tdo7kvv3">Planer</span>
          </div>
          <div className="text-white/40 text-sm" data-id="element-295" data-mp="3gbe06clok0cg">
            © {new Date().getFullYear()} MyPlaner. Всі права захищені.
          </div>
        </div>
      </footer>
    </div>;
}